<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import store from '@/store'
export default {
  name: 'App',
  data () {
    return {
      locale: zhCN
    }
  },
  created () {
  },
  watch: {
    $route () {
    }
  }
}
</script>

<style>
:global(.ant-btn-primary){
  color: #fff;
  background: #b99523 !important;
  border-color: #b99523 !important;
}
.ant-btn-primary:hover, .ant-btn-primary:focus{
  color: #fff;
  background: #b99523 !important;
  border-color: #b99523 !important;
}
.ant-btn-primary:active{
  color: #fff;
  background: #4dff97 !important;
  border-color: #4dff97 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue